<template lang="html">
  <div class="page-section">
    <div class="container">
      <div v-for="(item, index) in items" :key="`item-${index}`" :class="classes(parse(item))">
        <div class="image" :style="itemImage(item)"></div>
        <div class="text" @click="highlightField('text')">
          <div v-html="parse(item).text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

export default {
  name: 'TextImage',

  mixins: [parseComponent],

  props: {
    title: String,
    demoMode: Boolean,

    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  computed: {
    classes() {
      return (item) => {
        return [
          'text-image',
          item.text_position,
          item.text_width,
          item.text_alignment,
          {'is-boxed': item.boxed},
          {'is-fixed': item.fixed_image_height},
          {'has-spacing': item.bottom_spacing}]
      }
    },

    itemImage() {
      return (item) => {
        let image = this.demoMode ? this.parse(item).image_url : item.image_versions[0].url
        return `background-image:url('${image}')`
      }
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'
@import '../../stylesheets/base/theme'

.text-image
  display: flex
  min-height: 200px
  transition: all .3s ease-in-out

  &.is-fixed
    .image
      max-height: 300px

  &.is-boxed
    background: #fff
    box-shadow: $content-shadow

  &.has-spacing
    margin-bottom: $gap-medium

  &.text-left
    flex-direction: row-reverse

  &.text-right
    flex-direction: row

  .text
    padding: $gap-medium
    transition: all .3s ease-in-out
    display: flex

  &.text-left, &.text-right
    &.one-third
      .text
        flex-basis: percentage(1/3)

    &.half
      .text
        flex-basis: percentage(1/2)

    &.two-thirds
      .text
        flex-basis: percentage(2/3)

    &.three-quarters
      .text
        flex-basis: percentage(3/4)

    &.align-top
      .text
        align-items: top

    &.align-middle
      .text
        align-items: center

    &.align-bottom
      .text
        align-items: flex-end

  .image
    background-position: 50% 50%
    background-size: cover
    transition: max-height .3s ease-in-out
    width: 100%
    min-height: 200px
    max-height: 750px
    flex: 1
</style>
